export default __webpack_public_path__ + "static/media/LR.909caffe.svg";